import CustomDocumentType from '@/features/section-2/application/domain/entities/CustomDocumentType';
import { CustomDocumentTypeDto } from '../dto/res/CustomDocumentTypeResponseDto';

export function mapCustomDocumentTypeDtoToEntity(dto: CustomDocumentTypeDto): CustomDocumentType {
  return {
    section2DocTypeId: dto.section2DocTypeId,
    value: dto.value,
    label: dto.label,
  };
}
